const formatNumberCompact = (num: number): string => {
  if (num <= 999) return `${Math.max(num, 0)}`;

  const thousands = num / 1000;
  const roundedToOneDecimal = Math.round(thousands * 10) / 10;

  return `${Math.min(99, roundedToOneDecimal)}k`;
};

export default formatNumberCompact;
